export type SelectorDetails = {
  plugin: string;
  signature: string;
  serializedData: string;
  method: string;
  erc20OfInterest: string[];
};
